import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaCog,
  FaTable,
  FaFire,
  FaRegCalendarAlt,
} from "react-icons/fa";
import { GiStarShuriken } from "react-icons/gi";
import { IoCalendarNumberOutline } from "react-icons/io5";

const Sidebar = () => {
  const location = useLocation();

  return (
    <div className="d-flex flex-column h-100 bg-dark text-white p-3">
      <div className="mb-4 text-center">
        <h4 className="text-white">SP-admin</h4>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        className="bg-dark border-0"
      >
        <Menu.Item key="/" icon={<FaTachometerAlt />}>
          <Link to="/" className="text-decoration-none">
            Dashboard
          </Link>
        </Menu.Item>

        <Menu.Item key="/panchang" icon={<FaRegCalendarAlt />}>
          <Link to="/panchang" className="text-decoration-none">
            Panchang
          </Link>
        </Menu.Item>

        <Menu.Item key="/lagan" icon={<FaFire />}>
          <Link to="/lagan" className="text-decoration-none">
            Lagan
          </Link>
        </Menu.Item>

        <Menu.Item key="/nakshtra" icon={<GiStarShuriken />}>
          <Link to="/nakshtra" className="text-decoration-none">
            Nakshtra
          </Link>
        </Menu.Item>

        <Menu.Item key="/samvat" icon={<IoCalendarNumberOutline />}>
          <Link to="/samvat" className="text-decoration-none">
            Samvat
          </Link>
        </Menu.Item>

        <Menu.Item key="/users" icon={<FaUsers />}>
          <Link to="/users" className="text-decoration-none">
            Users
          </Link>
        </Menu.Item>

        <Menu.Item key="/settings" icon={<FaCog />}>
          <Link to="/settings" className="text-decoration-none">
            Settings
          </Link>
        </Menu.Item>
        <Menu.Item key="/table" icon={<FaTable />}>
          <Link to="/table" className="text-decoration-none">
            Table
          </Link>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default Sidebar;
